import { IMAGE_URL } from "../constants/index.js";

/**
 * GET /news-and-events returns items nested:
 *   { id, title, image (filename|null), description, date,
 *     category: {id,name}, audiences: [{id,name}] }
 * useNewsFilter / NewsEventCard / FilterPanel expect them flat:
 *   { id, title, image (url|null), description, date, category: string, audience: string[] }
 */
export function normalizeNewsEvents(rawItems) {
  if (!Array.isArray(rawItems)) return [];

  return rawItems
    .map((item) => ({
      id: String(item?.id ?? ""),
      title: item?.title ?? "",
      description: item?.description ?? "",
      date: item?.date ?? "",
      image: item?.image ? `${IMAGE_URL}/${item.image}` : null,
      category: item?.category?.name ?? "",
      audience: Array.isArray(item?.audiences)
        ? item.audiences.map((a) => a?.name).filter(Boolean)
        : [],
    }))
    .sort((a, b) => b.date.localeCompare(a.date)); // ISO dates sort lexically; newest first
}

/** Filter options come from the data, so new admin categories show up automatically. */
export function getFilterOptions(items) {
  const categories = {};
  const audiences = {};

  items.forEach((item) => {
    if (item.category) {
      categories[item.category] = (categories[item.category] || 0) + 1;
    }
    item.audience.forEach((name) => {
      audiences[name] = (audiences[name] || 0) + 1;
    });
  });

  return {
    categories: Object.keys(categories),
    audiences: Object.keys(audiences),
    itemCounts: { categories, audiences },
  };
}
